/* Ring Premier — small enhancements for the KeyIdeas diamond pages.
   Adds a "let our gemologist choose" box above the results. Purely additive:
   if the app's markup changes, nothing breaks, the box simply does not appear. */
(function () {
  if (!/\/pages\/(lab-diamonds|diamond-details)/.test(window.location.pathname)) return;
  var CFG = window.RPD_KIRB || {};
  var tries = 0;
  function place() {
    tries++;
    if (document.querySelector('.rpd-kirb-help')) return;
    var anchor = document.querySelector('.kirb-ring-section') ||
                 document.querySelector('[class*="kirb-results"]') ||
                 document.querySelector('#lab-diamonds .kirb-ring-item') ;
    if (!anchor) { if (tries < 40) setTimeout(place, 400); return; }
    var target = anchor.parentNode;
    var box = document.createElement('div');
    box.className = 'rpd-kirb-help';
    box.innerHTML = '<div><b>' + (CFG.title || "Don't want to compare thousands of stones?") + '</b>' +
                    '<span>' + (CFG.text || 'Tell our gemologist your budget and what matters. Three vetted, eye-clean options with a render, free, within two business days.') + '</span></div>' +
                    '<a href="' + (CFG.url || '/pages/start-your-design') + '">' + (CFG.cta || 'Let us choose') + '</a>';
    target.insertBefore(box, anchor);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
})();

/* rpd: replace KeyIdeas' default tagline on the diamond pages with ours (text-matched; classes unknown/unstable) */
(function(){
  var COPY='Every stone is IGI certified. Filter by shape, carat and budget, or text us and we will shortlist three.';
  function fix(){ var els=document.querySelectorAll('h2,h3,h4,p,div,span'); for(var i=0;i<els.length;i++){ var e=els[i]; if(e.children.length===0&&/exquisite array|meticulously curated|enhance your ring/i.test(e.textContent)){ e.textContent=COPY; e.style.textTransform='none'; e.style.letterSpacing='0'; e.style.fontFamily='var(--rp-sans, Jost, sans-serif)'; e.style.fontWeight='300'; e.style.fontSize='15px'; e.style.color='#5c5a56'; } } }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fix); else fix();
  var n=0,t=setInterval(function(){fix(); if(++n>20) clearInterval(t);},500);
})();
